t = require('app/scripts/views/internal/teacup-with-helpers')('board_menu_invitations')

module.exports = ->
  t.li ->
    t.a '.js-select', { href: '#', name: 'admins' }, ->
      t.check t.mustacheVar('invitations_admins'), 'admins'
      t.span '.sub-name', ->
        t.format 'allow-only-admins-to-add-and-remove-others'

  t.li ->
    t.a '.js-select', { href: '#', name: 'members' }, ->
      t.check t.mustacheVar('invitations_members'), 'all-members'
      t.span '.sub-name', ->
        t.format 'allow-members-and-admins-to-add-and-remove-others'
